import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import SvgIcon from 'vue-svgicon'
import VueObserveVisibility from 'vue-observe-visibility'
import VueTextareaAutosize from 'vue-textarea-autosize'
import CountryFlag from 'vue-country-flag'
import VueI18n from 'vue-i18n'
import translations from './translations'
import '@/components/icons'

Vue.config.productionTip = false;

Vue.use(SvgIcon, {
    tagName: 'svgicon'
})

Vue.use(VueI18n)
Vue.use(VueObserveVisibility)
Vue.use(VueTextareaAutosize)

Vue.component('country-flag', CountryFlag)

const i18n = new VueI18n({
  locale: 'nl',
  messages: translations,
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
